import React, { useRef } from "react";
import "../../Assets/css/services.css";
import "../../Assets/css/shopifyDevelopmentPage.css";
import { Helmet } from "react-helmet";
import { Container, Row, Col, Form, Image } from "react-bootstrap";

import "react-phone-input-2/lib/style.css";
import ShopifyDewelopmentImg from "../../Assets/images/shopify-img/shopify-development-img.png";
import ShopifybnnerTagImg from "../../Assets/images/shopify-img/shopify-banner-img.png";
import ShopifybnnerPartnerImg from "../../Assets/images/shopify-img/shopify-patners-img.png";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../../Assets/css/consultation.css";
import axios from "axios";
import { baseURL, postHeader } from "../../Helpers/request";
import swal from "sweetalert";
import "../../Assets/css/Sweetalert.css";
import Loader from "react-js-loader";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import Discover from "./shopifyStaticPage/Discover";
import OurPortfolio from "./shopifyStaticPage/OurPortfolio";
import ShopifyServices from "./shopifyStaticPage/ShopifyServices";
import OurDevelopmentProcess from "./shopifyStaticPage/OurDevelopmentProcess";
import DevelopmentExpertise from "./shopifyStaticPage/DevelopmentExpertise";
import HappyCustomers from "./shopifyStaticPage/HappyCustomers";
import Faqs from "./shopifyStaticPage/Faqs";

const ShopifyDevelopmentStaticPage = () => {
  const history = useHistory();
  const captchaRef = useRef(null);
  const [selectedDate, setSelectedDate] = React.useState("");
  const [firstname, setFirstname] = React.useState("");
  const [lastname, setLastname] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [phoneError, setPhoneError] = React.useState("");
  const [business, setBusiness] = React.useState("");
  const [website, setWebsite] = React.useState("");
  const [load, setLoad] = React.useState(false);
  const [captcha, setCaptcha] = React.useState(true);
  const [services, setServices] = useState([]);

  const SubmitAppointment = (e) => {
    e.preventDefault();
    // captchaRef.current.reset();
    const day = new Date(selectedDate).getUTCDay();
    if (phone.length > 7) {
      if (day == 6 || day == 0) {
        swal("please choose monday to friday", { icon: "warning" });
      } else {
        const data = {
          first_name: firstname,
          last_name: lastname ? lastname : "testing last name",
          email: email,
          phone: phone.length ? `+${phone}` : "",
          website_url: website,
          business_name: business,
          // date: `${new Date(selectedDate).getDate()}-${new Date(
          //   selectedDate
          // ).getMonth() + 1}-${new Date(selectedDate).getFullYear()}`,
          // time: time,
          // message: message,
          // timezone: timezone.label,
          services: "Shopify Development",
        };
        setLoad(true);
        axios
          .post(`${baseURL}/appointment/book_an_appointment`, data, {
            headers: postHeader,
          })
          .then((res) => {
            if (res.data.status == 1) {
              swal(res.data.message, { icon: "success" });
              setSelectedDate("");
              setFirstname("");
              setLastname("");
              setPhone("");
              setEmail("");
              //   setMessage("");
              //   setTime("10:00");
              //   setTimefeild("");
              //   setTimezone("");
              setBusiness("");
              setWebsite("");
              setLoad(false);
              history.push("/thankyou");
            } else {
              swal(res.data.message, { icon: "warning" });
              setLoad(false);
            }
          })
          .catch((error) => {
            if (error) {
              swal("something went wrong", { icon: "error" });
              setLoad(false);
            }
          });
      }
    } else {
      setPhoneError("Please Enter Valid Number");
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shopify Website Development Company | Belgium WebNet</title>
        <meta
          name="description"
          content="Shopify offers an easy-to-use platform that simplifies ecommerce for jewelers and customers. We can help you with Shopify website development, contact us now!"
        ></meta>
        <meta
          name="keywords"
          content="Shopify website development company"
        ></meta>
      </Helmet>
      <section className="bw_services_section_main bw_banner_shopify_development_section">
        <div className="bw_all_banner bw_banner_pricing bw_banner_shopify_development_bg">
          <Container className="bw_custome_container">
            <Row className="w-100 m-auto">
              <Col sm={12} md={7} lg={7}>
                <div className="text-left banner_left_text_box">
                  <h2 className="text-white">Expert</h2>
                  <Image
                    src={ShopifybnnerTagImg}
                    alt="shopify banner tag line image"
                  />
                  <h1 className="bw_banner_heading text-left">
                    Development Services
                  </h1>
                  <p className="bw_banner_sub_heading text-left px-0 pb-3">
                    Transform your e-commerce vision with custom Shopify
                    solutions. Our developers deliver high-performing, scalable
                    stores tailored to your brand. Build a stunning,
                    high-performing Shopify store with our expert developers.
                    Tailored solutions to elevate your e-commerce business.
                  </p>
                  <div className="shopify_btn_box_partner">
                    <button className="shopify_btn_outline">
                      Get Started Now
                    </button>
                    <div>
                      <Image
                        src={ShopifybnnerPartnerImg}
                        alt="shopify banner tag line image"
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                sm={12}
                md={5}
                lg={5}
                className="d-flex align-items-center justify-content-end"
              >
                <div className="bw_sp_book_a_free_consulation_box ">
                  <div className="bw_contact_form_inner_box">
                    <Form
                      className="bw_contact_us_form"
                      onSubmit={SubmitAppointment}
                    >
                      <Row>
                        <Col sm={12} md={12} lg={12}>
                          <div className="banner_form_headeing">
                            <h2 className="sho_heading">
                              Book A Free Consultations
                            </h2>
                            <p className="sho_sub_heading">
                              Let’s Chat! Your First Consultation is on Us
                            </p>
                          </div>
                        </Col>
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            {/* <Form.Label>Company Name<span style={{ color: !business?.length ? 'red' : 'black' }}>*</span></Form.Label> */}
                            <Form.Control
                              type="text"
                              placeholder="Company Name"
                              value={business}
                              onChange={(e) => setBusiness(e.target.value)}
                              required
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            {/* <Form.Label>First Name</Form.Label> */}
                            <Form.Control
                              type="text"
                              placeholder="Full Name"
                              value={firstname}
                              onChange={(e) => setFirstname(e.target.value)}
                              required
                            />
                          </Form.Group>
                        </Col>
                        {/* <Col sm={12} md={6} lg={6}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Last Name"
                              value={lastname}
                              onChange={(e) => setLastname(e.target.value)}
                              required
                            />
                          </Form.Group>
                        </Col> */}
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            {/* <Form.Label>Email Address</Form.Label> */}
                            <Form.Control
                              type="email"
                              placeholder="Email address"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                              className="rounded-0"
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            {/* <Form.Label>Phone Number<span style={{ color: !phone?.length ? 'red' : 'black' }}>*</span></Form.Label> */}
                            <PhoneInput
                              disableSearchIcon={true}
                              enableSearch={true}
                              country={"us"}
                              value={phone}
                              onChange={setPhone}
                              // onlyCountries={[
                              //   "us",
                              //   "cn",
                              //   "in",
                              //   "au",
                              //   "jp",
                              //   "hk",
                              //   "kw",
                              //   "gb",
                              //   "es",
                              //   "de",
                              //   "af",
                              // ]}
                              inputProps={{
                                name: "phone",
                                required: true,
                                autoFocus: false,
                              }}
                              isValid={(value, country) => {
                                console.log("value", value.length);
                                if (value.length < 10) {
                                  return "please enter valid number";
                                } else {
                                  return true;
                                }
                              }}
                            />
                            {!phoneError.length ? (
                              ""
                            ) : (
                              <p className="phone_field_error font-weight-light text-danger">
                                {phoneError}
                              </p>
                            )}
                          </Form.Group>
                        </Col>

                        <Col sm={12} md={12} lg={12}>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            {/* <Form.Label>Website</Form.Label> */}
                            <Form.Control
                              type="text"
                              placeholder="Website"
                              value={website}
                              onChange={(e) => setWebsite(e.target.value)}
                              required
                            />
                          </Form.Group>
                        </Col>

                        {/* <Col sm={12} md={12} lg={12}>

                          <Form.Label>Services</Form.Label>
                          <FormGroup aria-label="position" row className="mb-3">
                            <Col sm={12} md={6} lg={6} xl={4} className="pl-0">
                              <FormControlLabel
                                value="end"
                                label="Website Design & Development"
                                control={<Checkbox />}
                                labelPlacement="end"
                                className="bwn_consultation_form_checkbox"
                                onChange={() => selectService("Website Design & Development")}
                              />
                            </Col>


                            <Col sm={12} md={6} lg={6} xl={4} className="pl-0">
                              <FormControlLabel
                                value="end"
                                control={<Checkbox />}
                                label="Shopify Development"
                                labelPlacement="end"
                                className="bwn_consultation_form_checkbox"
                                onChange={() => selectService("Shopify Development")}
                              />
                            </Col>

                            <Col sm={12} md={6} lg={6} xl={4} className="pl-0">
                              <FormControlLabel
                                value="end"
                                control={<Checkbox />}
                                label="Social Media Marketing"
                                labelPlacement="end"
                                className="bwn_consultation_form_checkbox"
                                onChange={() => selectService("Social Media Marketing")}
                              />
                            </Col>

                            <Col sm={12} md={6} lg={6} xl={4} className="pl-0">
                              <FormControlLabel
                                value="end"
                                control={<Checkbox />}
                                label="Search Engine Optimization"
                                labelPlacement="end"
                                className="bwn_consultation_form_checkbox"
                                onChange={() => selectService("Search Engine Optimization")}
                              />
                            </Col>

                            <Col sm={12} md={6} lg={6} xl={4} className="pl-0">
                              <FormControlLabel
                                value="end"
                                control={<Checkbox />}
                                label="Email Marketing"
                                labelPlacement="end"
                                className="bwn_consultation_form_checkbox"
                                onChange={() => selectService("Email Marketing")}
                              />
                            </Col>

                            <Col sm={12} md={6} lg={6} xl={4} className="pl-0">
                              <FormControlLabel
                                value="end"
                                control={<Checkbox />}
                                label="Paid Marketing"
                                labelPlacement="end"
                                className="bwn_consultation_form_checkbox"
                                onChange={() => selectService("Paid Marketing")}
                              />
                            </Col>
                          </FormGroup>

                        </Col> */}
                        {/* <Col sm={12} md={12} lg={12}>
                          <div className="rcs_cap_main">
                            <ReCAPTCHA
                              className="rcs_g-recaptcha"
                              ref={captchaRef}
                              sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"
                              onChange={onChange}
                            />
                          </div>
                        </Col> */}
                      </Row>
                      <Row>
                        <Col sm={12} md={12} lg={12}>
                          <button
                            disabled={load || captcha ? false : false}
                            className="w-100 m-auto"
                          >
                            {load ? (
                              <div className="bw_loader_style">
                                <Loader
                                  type="spinner-default"
                                  bgColor={"#FFFFFF"}
                                  color={"#FFFFFF"}
                                  size={20}
                                />
                              </div>
                            ) : (
                              "submit"
                            )}
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {/* <div className="bw_sercices_image_section bw_shopify_development_section">
                    <Container className="bw_custome_container">
                        <Row className="w-100 m-auto">
                            <Col sm={12} md={6} lg={6} className="bw_sevices_left_text_box">
                                <div
                                    className="text-left"
                                >
                                    <h2>Shopify Development</h2>
                                    <p>
                                        Belgium WebNet is proud to be the leading Shopify partner that exclusively caters
                                        to the jewelry industry. The Shopify platform offers numerous advantages for online
                                        retailers, making it an incredibly powerful tool for e-commerce. Moreover, Shopify
                                        consistently updates and improves its features and functionality, ensuring that your
                                        website always stays up-to-date with the latest technology and trends.
                                    </p>
                                    <p>We understand that the jewelry industry has its unique requirements and challenges,
                                        which is why we specialize in developing custom Shopify websites that cater specifically
                                        to the needs of jewelry businesses. We have the expertise to create high-performing,
                                        user-friendly Shopify sites that help your brand succeed online, from product display
                                        and management to secure payment processing and shipping options.</p>
                                    <p>Our team specializes in creating Shopify websites that are not only great to look at but
                                        are also capable of driving sales and boosting your overall online presence.  Investing
                                        in a Shopify website is the perfect way to take your jewelry brand to the next level, and
                                        our Shopify experts are here to help you every step of the way. Contact us today to learn
                                        more and get started!</p>
                                </div>
                            </Col>
                            <Col sm={12} md={6} lg={6} className="bw_sevices_right_text_box">
                                <Image
                                    src={ShopifyDewelopmentImg}
                                    alt="Shopify Dewelopment Image"
                                    className="img-fluid"
                                />
                            </Col>
                        </Row>
                    </Container>
                </div> */}
        <Discover />
        <ShopifyServices />
        <OurPortfolio />
        <OurDevelopmentProcess />
        <DevelopmentExpertise />
        <HappyCustomers />
        <Faqs />
      </section>
    </>
  );
};

export default React.memo(ShopifyDevelopmentStaticPage);
